import { Expose } from 'class-transformer';

export class UserState {
  @Expose()
  event: string;

  @Expose()
  count: number;
}
